import {Component, inject, Signal, viewChild, ViewEncapsulation} from '@angular/core';
import {IApiControl, IUser, UserService} from 'frontier/nucleus';
import {DatePipe} from '@angular/common';
import {InternalNoteFormComponent} from './internal-note-form/internal-note-form.component';
import {toSignal} from '@angular/core/rxjs-interop';
import {ProcessOverviewStore} from '../../service/process-overview.store';
import {MatButton} from '@angular/material/button';
import {ICart} from '../../service/state.interface';
import {IForm} from 'frontier';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'kpi4me-internal-note-detail',
  templateUrl: './internal-note-detail.component.html',
  styleUrls: ['./internal-note-detail.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [MatButton, InternalNoteFormComponent],
})
export class InternalNoteDetailComponent {
  private _processOverviewService: ProcessOverviewStore = inject(ProcessOverviewStore);
  private _datePipe: DatePipe = inject(DatePipe);
  private _userService: UserService = inject(UserService);

  selectedCart: Signal<ICart> = this._processOverviewService.selectedCart;
  formRef: Signal<InternalNoteFormComponent> = viewChild(InternalNoteFormComponent);
  user: Signal<IUser> = toSignal<IUser>(this._userService.userGetGetLoginData());

  formData: IForm;

  addTimestamp(): void {
    const user: IUser = this.user();
    this.formData = this.formRef().formRef.formData;
    const formGroup: FormGroup = this.formRef().formRef.form;
    const formControl: FormControl = formGroup.get('InternalNotes;-1') as FormControl;
    const value = formControl.value;

    const newValue: string = value + '\n'
      + this._datePipe.transform(new Date(), 'dd.MM.yyyy HH:mm', undefined, 'de-DE')
      + ' ' + user.firstname + ' ' + user.lastname + ':\n';

    formControl.patchValue(newValue);

    this.formRef().formRef.saveValue(formControl, this.formData.formGroups[0])
  }

  onFormChange($event: IForm): void {
    console.log('form change', $event);
  }

  onInstanceInitialized($event: IApiControl): void {
    console.log('instanceInitialized event', $event);
  }
}
